module.exports = __webpack_public_path__ + "img/horangit_6.8e56197a.png";